import React from 'react';
import {useGetStorefrontsQuery} from '../../store/endpoints/StorefrontSettingsEndpoints';
import {Dropdown, IDropdownOption} from '@fluentui/react';
import useCan, { STOREFRONT_ADMIN } from '../../permissions/ability';

interface IStorefrontDropdownProps {
    label?: string;
    defaultLabel?: string;
    selected?: string;
    inheritedStorefrontId?: string;
    useId?: boolean;
    showMultiSelect?: boolean;
    onChange: (selected?: string) => void;
    onChangeStorefronts?: (storefronts: string[] | undefined) => void;
    contactStorefronts?: string[];
}

const StorefrontDropdown: React.FC<IStorefrontDropdownProps> = (props) => {
    const storefronts = useGetStorefrontsQuery();
    const [inherited, setInherited] = React.useState<string | undefined>();
    const canStorefrontAdmin = useCan(STOREFRONT_ADMIN);
    const [effectiveStorefronts, setEffectiveStorefronts] = React.useState<string[] | undefined>(props.contactStorefronts);
    const options: IDropdownOption[] = [
        { key: '', text: props.defaultLabel ?? 'Default' },
        ...storefronts.data?.items.map((storefront) => ({
            key: props.useId ? (storefront.id ?? '') : (storefront.subUrl ?? ''),
            text: storefront.name ?? ''
        })) ?? [],
    ]

    React.useEffect(() => {
        const sf = props.inheritedStorefrontId ? storefronts.data?.items.find((sf) => sf.id === props.inheritedStorefrontId) : undefined;
        setInherited(sf?.name);
    }, [props.inheritedStorefrontId, storefronts.data?.items])

    React.useEffect(() => {
        if(props.selected && props.selected  != '' && props.selected  != 'default' && !props.contactStorefronts?.includes(props.selected)){
            setEffectiveStorefronts([...(props.contactStorefronts ?? []), props.selected]);
        }
        else{
            setEffectiveStorefronts(props.contactStorefronts);
        }
    }, [props.contactStorefronts, props.selected])

    const storefrontOptions = storefronts.data?.items?.map(a => ({ key: a.id ?? '', text: a.name ?? '', isDisabled: (a.id === props.inheritedStorefrontId) })) ?? [];
    return (
        <div>
            <Dropdown
                label={props.label ?? 'Storefront'}
                selectedKey={props.selected}
                placeholder={inherited ? `Inherited: ${inherited}` : (props.defaultLabel ?? 'Default')}
                onChange={(e, option) => {
                    props.onChange(option?.key as string | undefined);
                }}
                options={options}
                disabled={!canStorefrontAdmin}
                />
            {props.showMultiSelect &&
            <Dropdown
                placeholder="Select storefronts"
                label='Storefronts'
                selectedKeys={effectiveStorefronts}
                onChange={(e,item) => {
                    if (!item) return;
                    props.onChangeStorefronts?.(
                        item.selected ? [...props.contactStorefronts ?? [], item.key as string] : props.contactStorefronts?.filter(key => key !== item.key),
                    );
                }}
                multiSelect
                options={storefrontOptions ?? []}
            />
            }
        </div>
    );
}

export default StorefrontDropdown;